import React from 'react';
import PropTypes from 'prop-types';

function DrugFoodMonographModal({ show, onHide, monoGraphData, loading }) {
  if (!show || !monoGraphData?.Monograph?.Sections) return null;

  return (
    <>
      <div className="modal-backdrop show" onClick={onHide} />
      <div className="modal cst-modal show" style={{ display: 'block' }}>
        <div className="modal-dialog modal-lg modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-body">
              <div className="title border-0">
                <h1>Monograph</h1>
                <button
                  type="button"
                  className="btn-close"
                  onClick={onHide}
                  aria-label="Close"
                />
              </div>

              {loading ? (
                <div className="text-center p-4">Loading...</div>
              ) : (
                <ul className="modal-list">
                  {monoGraphData.Monograph.Sections.map((section, index) => (
                    <li key={`monograph-section-${index}`}>
                      <h3>{section.Title}</h3>
                      <p>{section.Text}</p>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

DrugFoodMonographModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  monoGraphData: PropTypes.object,
  loading: PropTypes.bool,
};

export default DrugFoodMonographModal;
